import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { facebook, instagram } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#E68309" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center black bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/brucheria.ca/"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Bruncheria Facebook"
              />
            </CFLink>
            <CFLink
              target="_blank"
              href="https://www.instagram.com/bruncheria.ca/?hl=en"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Bruncheria Facebook"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#E68309" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter black bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/brucheria.ca/"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Bruncheria Facebook"
              />
            </CFLink>
            <CFLink
              target="_blank"
              href="https://www.instagram.com/bruncheria.ca/?hl=en"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Bruncheria Facebook"
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
